import { Component } from 'base/js/aem';

class Feedback extends Component {
    init() {
        const container = document.getElementById('feedback-container');
        const iframe = document.createElement('iframe');
        const url = `${window.location.host }`;
        iframe.src = url.indexOf('.amd.com') > -1 ? this.props.feedbackurl
            .replace('/content/amd/live-site/', '/')
            .replace('/content/amd/language-masters/', '/') : this.props.feedbackurl;
        iframe.scrolling = 'no';
        iframe.title = 'Feedback';
        iframe.loading = 'lazy';
        container.appendChild(iframe);
    }
}

export { Feedback };
